import { render, staticRenderFns } from "./CheckoutModalConfirmOrder.vue?vue&type=template&id=71b0bc3a&scoped=true"
import script from "./CheckoutModalConfirmOrder.vue?vue&type=script&lang=js"
export * from "./CheckoutModalConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./CheckoutModalConfirmOrder.vue?vue&type=style&index=0&id=71b0bc3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0bc3a",
  null
  
)

export default component.exports